module.exports = __webpack_public_path__ + "img/GP3_Slovenia -Academy for women entrepreneurs (AWE).ef531d3c.jpg";